import { DrugTypeEnum, DrugCategoryEnum } from "typings/types"
import { VideoConstraintsEnum } from "shared/Analytics"
import { CurrentUser } from "graphql/smart-queries/user"

export interface IAnalytics {
  onLeadStep(user: RequiredLeadData): void
  onRegistration(user: RequiredUserData): void
  onSubscribe(user: RequiredUserData, purchase: PurchaseData): void
  onPageLoad(user?: UserData): void
  onAddUpsellProduct(user: UserData, productId: number): void
  onNotEligibleUser(user?: UserData): void
  onStartVideoRecording(user?: UserData): void
  onStartVideoUpload(user?: UserData): void
  onPhotoIdUpload(user?: UserData): void
  onVideoConstraintsFailed(reason: VideoConstraintsEnum, data?: VideoFormatInfo): void
  onUserVersionFunneled(user?: UserData, funnel?: string): void
  onVideoSectionStarted(user?: UserData): void
}

export type UserData = {
  id?: number
  accountCreated?: boolean
  accountCreationDate?: string
  leadSource?: string | null
  eCommerceFlow?: boolean
  eligible?: boolean
  ineligible_reason?: string
  cart?: number[]
} & Partial<CurrentUser>

/**
 * must be 3-letter ISO currency code, such as USD or GBP
 */
export enum PurchaseValueCurrencyEnum {
  USD = "USD"
}

export type RequiredUserData = Overwrite<UserData, { id: number }>

/**
 * CRM requires eCommerceFlow to be set on the lead event
 * https://docs.google.com/spreadsheets/d/1fFwZOBv04alJ2r0TryANP-s8_5ZoJ0WJMy3GLg6MIZc/edit#gid=0
 */
export type RequiredLeadData = Overwrite<RequiredUserData, { eCommerceFlow: boolean }>

export type VideoFormatInfo = {
  format: string
}

export type PageData = {
  path: string
  url: string
}

export type PurchaseData = {
  purchaseDate: string
  firstPurchase: boolean
  productIds?: number[]
  nextBillingDate?: boolean
  eCommerceFlow?: boolean
  otcFlow?: boolean
  cartItems?: string
  drugCategories?: DrugCategoryEnum[]
  needConsulation?: boolean
  value?: number
  currency?: PurchaseValueCurrencyEnum
}

export type ProductData = {
  productId: number | string
  medicationType: DrugTypeEnum
}

export type VideoConstraintsInfo = {
  reason: VideoConstraintsEnum
} & VideoFormatInfo

export type TrackData = UserData & Partial<ProductData> & Partial<PurchaseData> & Partial<VideoConstraintsInfo>

export type IdentifyData = UserData & {
  server_source?: string
  funnel?: string
}

export type LoggingData = {
  event: string
  logData?: UserData | VideoFormatInfo
}
